import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormInput, ProjectListHeader, FormSelect } from '../../../components'
import { back, push } from '../../../actions/nav-actions'
import { fetchProjectingResults, putProjectingResults } from '../../../api';
import { notify, getDictionary } from '../../../utils'

const categories = ['outcomes', 'output', 'impact'];
const types = ['qualitative', 'quantitative'];

class EvaluateContext extends Component {
  state = {
    project: {},
    is_loading: false,
    error: undefined,
    data: {}
  }
  constructor(props) {
    super(props);
    this.request = this.request.bind(this);
    this.getParams = this.getParams.bind(this);
    this.client = getDictionary(props.dictionary);
    this.getText = this.getText.bind(this);
  }
  getText(tag, category = 'projecting_results') {
    return this.client.get(category, tag);
  }
  getParams() {
    return this.props.match.params || {};
  }
  componentDidMount() {
    const params = this.getParams();
    this.setState({ is_loading: true, error: undefined }, () => {
      fetchProjectingResults(this.props.user.token,
        params.organization,
        params.code
      )
        .then((data) => this.setState({ is_loading: false, data }))
        .catch(err => this.setState({ is_loading: false, error: err }))
    });
  }
  request() {
    const params = this.getParams();
    putProjectingResults(
      this.props.user.token,
      params.organization,
      params.code,
      {
        ...this.state.data,
        goal_results: this.state.data.options.goals
      }
    )
      .then((data) => notify("Update informations", "Successfully updated!"))
      .catch((err) => notify('Error', err.message, 'error'))
  }
  render() {
    if (this.state.error) return <span>{this.state.error.message}</span>
    if (!this.state.data.results || this.state.is_loading) return <span>Loading data...</span>
    let { results, options } = this.state.data;
    return (
      <React.Fragment>
        <ProjectListHeader title="GUIDANCE ON ANALYZING RESULTS" />
        <div style={{ marginHorizontal: 24 }}>
          <p>{this.getText('constituting_success_question')}</p>
          <FormInput
            value={results.questions.constituting_success}
            onChange={(text) => {
              let { results } = this.state.data;
              results.questions.constituting_success = text;
              this.setState({
                data: {
                  ...this.state.data,
                  results
                }
              })
            }}
            placeholder="" />

          <p>{this.getText('contribution_question')}</p>
          <FormInput
            value={results.questions.contribution}
            onChange={(text) => {
              let { results } = this.state.data;
              results.questions.contribution = text;
              this.setState({
                data: {
                  ...this.state.data,
                  results
                }
              })
            }}
            placeholder="" />

          <p>{this.getText('theory_of_change_question')}</p>
          <FormInput
            value={results.questions.theory_of_change}
            onChange={(text) => {
              let { results } = this.state.data;
              results.questions.theory_of_change = text;
              this.setState({
                data: {
                  ...this.state.data,
                  results
                }
              })
            }}

            placeholder="" />

        </div>

        {options.goals.map((goal, index) => {
          return (
            <div key={index}>
              <ProjectListHeader title={`Goal ${index + 1}: ${goal.name}`} />
              {goal.indicators.length === 0 &&
                <p>No Baselines</p>
              }
              {goal.indicators.map((indicator, indicator_index) => {
                return (
                  <div
                    key={indicator_index}>
                    <p>{indicator.indicator.measure}</p>
                    <div className="row" style={{ marginBottom: 16, marginTop: 16 }}>
                      <FormSelect
                        style={{ flex: 1, marginRight: 12 }}
                        value={indicator.result.category || undefined}
                        defaultValue={indicator.result.category || undefined}
                        onChange={(option) => {
                          let { options } = this.state.data;
                          options.goals[index].indicators[indicator_index].result.category = option.value;
                          this.setState({
                            data: { ...this.state.data, options }
                          });
                        }}
                        placeholder="Select a category"
                        className="col-4"
                        options={categories.map(c => ({ label: c, value: c }))} />
                      <FormSelect
                        style={{ flex: 1, marginLeft: 12 }}
                        value={indicator.result.type || undefined}
                        defaultValue={indicator.result.type || undefined}
                        onChange={(option) => {
                          let { options } = this.state.data;
                          options.goals[index].indicators[indicator_index].result.type = option.value;
                          this.setState({
                            data: { ...this.state.data, options }
                          });
                        }}
                        placeholder="Select a type"
                        className="col-4"
                        options={types.map(t => ({ label: t, value: t }))} />
                    </div>
                    <FormInput
                      value={indicator.result.input}
                      onChange={(text) => {
                        let { options } = this.state.data;
                        options.goals[index].indicators[indicator_index].result.input = text;
                        this.setState({
                          data: { ...this.state.data, options }
                        });
                      }}
                      containerStyle={{ marginTop: 16 }}
                      placeholder="Input data here" />
                  </div>
                )
              })}

              {goal.subgoals.map((subgoal, subgoal_index) => {
                return (
                  <div key={subgoal_index}>
                    <ProjectListHeader title={`Subgoal ${subgoal_index + 1}.${index + 1}: ${subgoal.name}`} />
                    {subgoal.indicators.length === 0 &&
                      <p style={{ marginHorizontal: 24 }}>No Baselines</p>
                    }
                    {subgoal.indicators.map((indicator, indicator_index) => {
                      return (
                        <div
                          key={indicator_index}
                          style={{ marginHorizontal: 24, marginBottom: 16 }}>
                          <p>{indicator.indicator.measure}</p>
                          <div className="row" style={{ marginTop: 16, marginBottom: 16 }}>
                            <FormSelect
                              style={{ flex: 1, marginRight: 12 }}
                              value={indicator.result.category || undefined}
                              defaultValue={indicator.result.category || undefined}
                              onChange={(option) => {
                                let { options } = this.state.data;
                                options.goals[index].subgoals[subgoal_index].indicators[indicator_index].result.category = option.value;
                                this.setState({
                                  data: { ...this.state.data, options }
                                });
                              }}
                              placeholder="Select a category"
                              className="col-4"
                              options={categories.map(c => ({ label: c, value: c }))} />
                            <FormSelect
                              style={{ flex: 1, marginLeft: 12 }}
                              value={indicator.result.type || undefined}
                              defaultValue={indicator.result.type || undefined}
                              onChange={(option) => {
                                let { options } = this.state.data;
                                options.goals[index].subgoals[subgoal_index].indicators[indicator_index].result.type = option.value;
                                this.setState({
                                  data: { ...this.state.data, options }
                                });
                              }}
                              placeholder="Select a type"
                              className="col-4"
                              options={types.map(t => ({ label: t, value: t }))} />
                          </div>
                          <FormInput
                            value={indicator.result.input}
                            onChange={(text) => {
                              let { options } = this.state.data;
                              options.goals[index].subgoals[subgoal_index].indicators[indicator_index].result.input = text;
                              this.setState({
                                data: { ...this.state.data, options }
                              });
                            }}
                            containerStyle={{ marginTop: 16 }}
                            placeholder="Input data here" />
                        </div>
                      )
                    })}
                  </div>
                )
              })}
            </div>
          )

        })}

        <button
          className="btn btn-info"
          onClick={this.request.bind(this)}
          style={{ marginTop: 24, marginBottom: 24 }}>
          SAVE
        </button>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({ ...state.localStorage, user: state.authReducer.user });

const mapDispatchToProps = dispatch => ({
  back() {
    dispatch(back())
  },
  push(routeName) {
    dispatch(push(routeName))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(EvaluateContext);


// WEBPACK FOOTER //
// ./src/routers/Projects/Formularies/ProjectingResultsFormularies.js